// 全局状态-公共
import to from 'await-to-js';
import * as apis from "@/api/interface/global";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    foldAside: false, //全局左侧栏是否折叠
    outCallList: ["1780", "1781", "1782", "1783", '1202'],
    lusUserCti: {}, //坐席信息
    wxGzhUnRead: {}, //公众号未回复数量
    seatClockStatus: 'info',  //坐席签到状态
  }),
  getters: {
    // aa(state, getters, rootState, rootGetters){
    //   // state getters 局部状态
    //   // rootState rootGetters 根部状态
    // },
  },
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
    // 切换全局左侧栏折叠状态
    handleFoldAside(state, flag){
      state.foldAside = flag !== undefined ? flag : !state.foldAside;
    },
    // 更新坐席签到状态
    setSeatClockStatus(state, flag){
      state.seatClockStatus = flag;
    }
  },
  actions: {
    // 获取坐席信息
    async getLusUserCti(ctx, payload = {}) {
      const [err, {data}] = await to (apis.getQueryAgent(payload));
      ctx.commit("update", {
        lusUserCti: !err && data ? data : {},
      });
      return data;
    },
    // 获取打卡信息
    async getClockInStatus(_, payload = {}) {
      const [, res] = await to (apis.getClockInStatus(payload));
      return res;
    },
    // 打卡
    async clockIn(_, payload = {}) {
      const [, res] = await to (apis.clockIn(payload));
      return res;
    },
    // 获取公众号未回复数量
    async getWxGzhUnRead(ctx, payload = {}) {
      const [err, {data}] = await to (apis.getWxGzhUnRead(payload));
      ctx.commit("update", {
        wxGzhUnRead: !err && data ? data : 0,
      });
      return data;
    },




    
    // async aaAsync(context, payload) {
    //   // context {state, getters, commit, dispatch, rootState, rootGetters}
    //   // state getters commit, dispatch 局部状态
    //   // rootState rootGetters 根部状态
      
    //   // 向本模块派发action，需要把局部模块名去掉
    //   context.commit('aa', payload);

    //   // commit, dispatch 若要访问全局空间
    //   // 需将 { root: true } 作为第三参数传给 dispatch 或 commit 即可。、
    //   context.commit('aa', payload, { root: true });
    //   context.dispatch('aaAsync', null, { root: true });

    //   // 在A局部空间，向B局部空间派发action
    //   context.commit('user/bb', payload, { root: true });
    //   context.dispatch('user/bbAsync', payload, { root: true });
    // },
  },
  modules: {
  }
}